// constants
import {
    CONTACT_US,
    SALES_DASHBORAD,
    TRANSACTION_ID,
    DETAILS,
} from './constants';
import {
    SegmentEventButtonNames,
    SegmentEventActionNames,
} from 'utils/segment/constants';

export function getSegmentProps(id: string) {
    switch (id) {
        case TRANSACTION_ID:
            return {
                button_name: SegmentEventButtonNames.MY_TRANSACTION,
                action_name: SegmentEventActionNames.CLICK_MY_TRANSACTIONS,
            };

        case SALES_DASHBORAD:
            return {
                button_name: SegmentEventButtonNames.REPORT_DASHBOARD,
                action_name: SegmentEventActionNames.CLICK_REPORT_DASHBOARD,
            };

        case CONTACT_US:
            return {
                button_name: SegmentEventButtonNames.CONTACT_US,
                action_name: SegmentEventActionNames.CLICK_CONTACT_US,
            };
        case DETAILS:
            return {
                button_name: SegmentEventButtonNames.DETAILS,
                action_name: SegmentEventActionNames.CLICK_DETAILS,
            };

        default:
            return {
                button_name: SegmentEventButtonNames.ADD_REMOVE_SUB_DEALER,
                action_name:
                    SegmentEventActionNames.CLICK_ADD_REMOVE_SUB_DEALERS,
            };
    }
}
